<app-card>
  <div class="flex flex-col gap-8">
    <div class="flex flex-nowrap gap-1 w-full">
      <app-select class="ml-auto w-52" [options]="sortOptions" [formControl]="sortControl" label="{{ 'table.sort-by' | translate }}"></app-select>
    </div>

    <app-table [columns]="columns" [data]="data$ | async" (pageChange)="changePage($event)"></app-table>
  </div>
</app-card>
